import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBurgerMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 24,
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m24 6.712v-2.712h-24v2.712zm0 6.552v-2.544h-24v2.544zm0 6.72v-2.712h-24v2.712z",
		fill: "#000"
	})
});
export default SvgBurgerMenu;
